import React from 'react';

const InventoryCards = ({ category }) => {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden">
      <div className="p-6">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">{category.name}</h3>
          <span
            className={`px-2 py-1 text-xs rounded-full ${
              category.reusable ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
            }`}
          >
            {category.reusable ? 'Reusable' : 'Consumable'}
          </span>
        </div>

        <div className="mt-4">
          <p className="text-3xl font-bold text-gray-900">{category.total}</p>
          <p className="mt-1 text-sm text-gray-500">
            {category.damaged > 0 ? `${category.damaged} damaged` : 'No damaged items'}
          </p>
        </div>

        <div className="mt-6">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-black rounded-full"
              style={{ width: `${Math.min(100, (category.total / 200) * 100)}%` }}
            ></div>
          </div>
          <p className="mt-1 text-xs text-gray-500 text-right">
            {Math.round((category.total / 200) * 100)}% of max capacity
          </p>
        </div>
      </div>
    </div>
  );
};

export default InventoryCards;
